module.exports = __webpack_public_path__ + "img/logo.49293a22.png";